import {
  Entities
} from '../entities';
import {IVendorListEntity, IVendorListItemClassificationAssignmentEntity} from '../VendorList';
import {IVendorEntity} from '../Vendor';
import {Scraper} from './scraper.api';
import {IProjectEntity} from '../Project';

export namespace Vendor {
  export type Endpoint = 'vendors';

  export type GetProjectVendorsParams = {
    projectId: string | number;
  };
  export type GetProjectVendorInfoParams = {
    vendorAssignmentId: string | number;
  }

  export type GetVendorInfoParams = {
    vendorId: string | number;
  }

  export interface ProjectVendorList extends Omit<IVendorListEntity, keyof Omit<Entities.BaseEntity, 'id'> | 'project' | 'subContractors'> {
    subList: ProjectVendorListInfo[]
  }

  export type CreateVendorListParams = Pick<IVendorListEntity,
    'projectId'> & {
    dirRegNo: string;
    gcClassifications?: number[];
    bidAmount?: number;
  };
  export interface ProjectVendorListInfo extends Omit<IVendorEntity, keyof Omit<Entities.BaseEntity, 'id' | 'isActive'> | 'validations'> {
    vendorId: number;
    projectId: number;
    project: IProjectEntity;
    classifications: Pick<IVendorListItemClassificationAssignmentEntity, 'id' | 'classification'>[];
    notifications: VendorNotification[];
    validations: GetVendorValidations[];
    removeRequested: boolean;
    inActiveMessage: string;
    inActivateById?: number;
    inActiveDate?: Date;
  }
  export type GetVendorValidationParam = {
    validationId: string | number;
  }

  export interface GetVendorValidations extends Entities.BaseEntity {
    vendorId: number;
    success: boolean;
    system: Scraper.DataSystem;
    message?: string;
    content?: string;
    contentUrl?: string;
    log?: ILogData[];
    pdfCompletedOn: Date;
    validationCompletedOn: Date;
    type: ValidationTypeEnum;
    originRecordId?: number;
  }

  enum ValidationTypeEnum {
    Standard = 'Standard',
    BidAssignment = 'BidAssignment',
    ContractAssignment = 'ContractAssignment',
    Manual = 'Manual',
    InfoUpdate = 'InfoUpdate',
  }

  export interface ILogData {
    date: Date;
    message: string;
    isError: boolean;
    data?: Object;
  }
  export type GetVendorInfoResponse = Omit<GetProjectVendorInfoResponse, 'classifications'>;

  export type GetProjectVendorInfoResponse = ProjectVendorListInfo;

  export interface VendorNotification {
    title: string;
  }

  export type CreateVendorParams = Omit<IVendorEntity, keyof Entities.BaseEntity |
    'dirRegFrom' |
    'dirRegTo' |
    'licFrom' |
    'licTo' |
    'dirRegNoVerified' |
    'licNoVerified' |
    'licLastRefresh' |
    'dirRegLastRefresh' |
    'isActive' |
    'licActive' |
    'dirRegActive' |
    'licenses' |
    'crafts' |
    'validations' |
    'dbaName'>;

  export type CreateProjectVendorParams = {
    projectId: number | string;
    classifications: number[];
    listId: number;
  } & CreateVendorParams;

  export type BulkVendorImportParams = string[];

  export type EndpointActionParam = 'assignment' | 'inactivateAssignment' | 'vendor' | 'validateCslb' | 'validateDir' | 'bulkImport' | 'removeAssignment';

  export type UpdateVendorInfo = Partial<Pick<IVendorEntity,
    'id' |
    'name' |
    'dirRegNo' |
    'dirRegFrom' |
    'dirRegTo' |
    'licNo' |
    'address1' |
    'address2' |
    'address3' |
    'city' |
    'state' |
    'zip' |
    'emailAddress' |
    'isActive' |
    'dbaName'>>;

  export type VendorAssignmentInactiveData = {
    assignmentId: number;
    message: string;
  }

  export type UpdateProjectVendor = Partial<Omit<CreateProjectVendorParams,
    'projectId' |
    'classifications' |
    'listId'>> & {
    vendorId: number;
    vendorAssignmentId?: number | string;
    classificationIds?: number[];
  }
  export type RevalidateDIRParams = {dirRegNo: string; vendorId: number;};
  export type RevalidateCSLBParams = {licNo: string; vendorId: number;};
  export type GetVendorSearchParams = { search: string; };

  export type RemoveAssignmentParams = {
    projectId: number;
    message: string;
    data: RemoveAssignmentData[];
  };
  export type DoRemoveAssignmentParams = {
    assignmentId: number;
    accept: boolean;
    message?: string;
  }

  export type RemoveAssignmentData = {
    assignmentId: number;
    vendorId: number;
    name: string;
    dirNo: string;
    cslbNo?: string;
    classifications: string;
    message?: string;
    accepted?: boolean;
    addressedOn?: Date;
    addressedByAccountId?: number;
    addressedByName?: string;
  };
  export type GetPWMVendorSearchParams = { pwmVendorSearch: string; }

  export type SearchPWMVendorResult = Pick<IVendorEntity,'id' | 'name' | 'dbaName' |'dirRegNo' | 'licNo' | 'projectAssignments' | 'dirRegActive' | 'licActive' | 'isActive'>;

  export type VendorDetail = IVendorEntity;

  export type SearchEndpoint = 'vendorSearch';
  export type VendorDetailAction = 'vendorDetail';
  export type GetVendorDetailParam = {vendorId: string | number};
  export type SearchResult = Pick<IVendorEntity,
    'id' |
    'name' |
    'dirRegNo' |
    'dirRegFrom' |
    'dirRegTo' |
    'licNo' |
    'licMessage' |
    'address1' |
    'address2' |
    'address3' |
    'city' |
    'state' |
    'zip' |
    'emailAddress'> & {
    craft?: string,
    dbaNames?: string[];
  };
}
